function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg from 'ha/ui/next/SvgIcon';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M23.751 16.793L12.767 4.322a1.066 1.066 0 0 0-1.539 0L.249 16.793a.987.987 0 0 0 .107 1.414l1.85 1.557a1.028 1.028 0 0 0 1.438-.111l8.165-9.453a.25.25 0 0 1 .379 0l8.168 9.45a1.021 1.021 0 0 0 .7.349 1 1 0 0 0 .741-.238l1.851-1.558a.989.989 0 0 0 .107-1.414z"
});

var SvgArrowButtonUpBold = function SvgArrowButtonUpBold(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgArrowButtonUpBold;